import gql from 'graphql-tag';
export default gql`
  mutation fetchRatebook($searchFilters: RatebookFilterInput) {
    fetchRatebook(searchFilters: $searchFilters) {
      results {
        rows {
          id
          referenceId
          catalogVehicleId
          quotationTemplateId
          catalogPrice
          consumerPrice
          monthLeaseprice
          weekLeaseprice
          fiscalValue
          netPrice
          discountRate
          discountAmount
          excessDistancePrice
          distance
          distanceUnit
          duration
          durationUnit
          creationDate
          leasecompany
          catalogYear
          vehicleDescription
          vehicleMake
          vehicleModel
          vehicleCategory
          vehicleNaturegroup
          cabType
          vehicleTrim
          vehicleBodystyle
          vehicleBodytype
          vehicleNrofdoors
          vehicleDrivetrain
          vehicleWheelbase
          vehicleTransmissiongroup
          vehicleTransmission
          vehiclePrimaryfueltype
          vehicleNrofseats
          vehicleFueltype
          brokerId
          brokerName
          imagespath
          imagespathDrive
          imagespathBody
          imagespathTrim
          jatoImagepath
          jatoImagepathBase
          jatoImagepathTrim
          vehicleFinance
          vehicleFinanceWeekly
          vehicleRunningCost
          vehicleRunningCostWeekly
          quoteRefId
        }
        totalCount
      }
    }
  }
`;
